import React, { useEffect, useState } from 'react';
import Loader from '../Common/loader';
import FormHeading from '../../UI_Design/FormComponents/Heading/FormHeading';
import RadioButtonGroup from '../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup';
// import { useDispatch } from 'react-redux';
// import { saveCourtRecordDeclaration } from '../../../Actions/courtRecordAction'; // Example action
import TextField from '../OnbordingForm/TabsAndContent/textField';
import { saveCourtRecordCheckData } from '../../Actions/CourtRecordCheckActions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const MainFormCourtRecordCheckDeclaration = (props) => {
    const {formData, candidateDetails} = props
    const [isLoading, setIsLoading] = useState(false);
    const [hasCourtRecord, setHasCourtRecord] = useState(null); // Track Yes/No selection
    const [address, setAddress] = useState('');
    const [cnrNumbers, setCnrNumbers] = useState('');
    const [fields, setFields] = useState({});
    const [candidateData, setCandidateData] = useState({})
    const [saveData, setSavePayload] = useState({});
    const [errData, setErrData] = useState({});
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
    let clientId;
  
    if(user && (user?.client_id || user?.bridge_client_id)){
      clientId = user?.client_id || user?.bridge_client_id;  
    }

    
    useEffect(() => {
        if(formData && formData?.declarationFormFields){
            setFields(formData?.declarationFormFields);
            setCandidateData(formData?.formData);

            Object.values(formData?.declarationFormFields).map((item) => {
                setSavePayload((prev) => ({
                    ...prev,
                    [item?.id] : item?.value
                }))
            })

            if(formData?.declarationFormFields?.declaration_question && formData?.declarationFormFields?.declaration_question?.value != ""){
                if(formData?.declarationFormFields?.declaration_question?.value == 'Yes' || formData?.declarationFormFields?.declaration_question?.value == 'YES'){
                    setHasCourtRecord(true);
                }else{
                    setHasCourtRecord(false);
                }
            } 
        }
    },[formData])

    const handleRadioButtonChange = (index, id, selectedOption, option) => {
        setHasCourtRecord(index === 0); // Assuming "Yes" is the first option (index 0)
        setSavePayload((prev) => ({
            ...prev,
            [id] : option
        }))
    };

    const handleInputChange = (val) => {

        var cols = document.getElementById(val[0].err_id);
        cols.innerHTML = "";
        
        setSavePayload((prev) => ({
            ...prev,
            [val[0]?.id] : val[0]?.value
        }))
        
        // if(name[0]?.name == 'address'){
        //     setAddress(name[0]?.value);
        // }

        // if(name[0]?.name == 'CNR'){
        //     setCnrNumbers(name[0]?.value);
        // }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let err = formValidation();

        
        if(err == true){
            window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }else{

            
            let recordData = {};
            let saveFields = {...saveData};

            if (hasCourtRecord == true) {
                const declarationAddress = fields?.declaration_address;
                saveFields[declarationAddress?.id] = ''
            } else {
                const declarationCnrNumber = fields?.declaration_cnr_number;
                saveFields[declarationCnrNumber?.id] = ''
            }
            
            const obj = {
                group: "declaration_details",
                ...saveFields
            };
            

        // recordData.check_data = { [caseCheckId]: { "group": "address", ...newRecord, ...additonalData } };
        recordData.check_data = { [formData?.declarationFormFields?.case_check_id]: obj };
        recordData.case_check_id = formData?.declarationFormFields?.case_check_id;
        
        console.log(recordData);
        dispatch(saveCourtRecordCheckData(recordData, saveCallback));
    }

    };

    const saveCallback = (data) => {

        const group = data.group ? data.group.group_id : "";
        const hasNextCheck = data.nextCheck != "" ? true : false;
        const reference = data.reference_number;

        if (
            group == "profile_preview" ||
            data.group == "profile_preview"
          ) {
            navigate(`/case-initiation/profile-preview/${reference}`);
          } else if (typeof group != "undefined" && group != "") {
            navigate(`/case-initiation/check-detail/${reference}/${group}`);
          }
    }


    const formValidation = () => {
        let isError = false;
      
        // Resetting all errors first
        const errorElements = document.getElementsByClassName("err text-danger");
        for (let i = 0; i < errorElements.length; i++) {
          errorElements[i].innerHTML = "";
        }
      
        // Check if the court record field is required
        if (!hasCourtRecord == true) {
          const declarationAddress = fields?.declaration_address;
          if (declarationAddress?.is_mandatory == 1) {
            isError = validateField(declarationAddress);
          }
        } else {
          const declarationCnrNumber = fields?.declaration_cnr_number;
          if (declarationCnrNumber?.is_mandatory == 1) {
            isError = validateField(declarationCnrNumber);
          }
        }
      
        // Return true if there are any errors, false otherwise
        return isError;
      };

              // Reusable function to handle field validation
        const validateField = (field, errorMessage = "This field is required.") => {
          const fieldId = field?.id;
          const elementErrorId = `err-${fieldId}`;
          const fieldValue = saveData?.[fieldId];
      
          if (
            fieldValue === undefined ||
            fieldValue === null ||
            fieldValue.trim() === ""
          ) {
            const errorElement = document.getElementById([elementErrorId]);
            if (errorElement) {
              errorElement.innerHTML = errorMessage;
            //   isError = true;
            return true;
            }
          }
        };

        const handleSubmitForPreview = (e) => {
            e.preventDefault();
            const currentUrl = window.location.href;
            const [partA, partB] = currentUrl.split("/check-detail/");
            const [reference, route] = partB.split("/");
            navigate(`/case-initiation/profile-preview/${reference}`);
          };
      

    return (
        <>
            {isLoading && <Loader />}
            <div className="p-3" style={{ background: "#F9FAFB" }}>
                <div className="formHeading border-bottom">
                    <FormHeading
                        heading="Court Record Check Declaration"
                    />
                </div>

                {/* <div className="my-3">
                    <p className='m-0 my-2'>Have you ever been convicted by any court of law for any civil or criminal offence or is there any criminal case pending against you?</p>
                    <RadioButtonGroup options={["Yes", "No"]} onChange={handleRadioButtonChange} />
                </div> */}

                {fields?.declaration_question && 
                    <div className="my-3">
                    <p className='m-0 my-2'>{fields?.declaration_question?.label}</p>
                    <RadioButtonGroup options={Object.values(fields?.declaration_question?.options)} id={fields?.declaration_question?.id} onChange={handleRadioButtonChange} value={fields?.declaration_question?.value}/>
                    </div>
                }

                {hasCourtRecord === false && fields?.declaration_address && (
                    <div className="my-3">
                        {/* <p>This is to certify that I, Candidate name (Non-editable), Indian Citizen, of Legal Age- Age (Based on DOB, Non-editable), son/daughter of Father’s name (As filled in Basic details, Non-editable) and resident of</p> */}
                        {/* <p>{`This is to certify that I, ${candidateData?.first_name} ${candidateData?.middle_name} ${candidateData?.last_name}, Indian Citizen, of Legal Age- ${candidateData?.age}, son/daughter of ${candidateData?.father_name} and resident of`}</p> */}
                        <p>This is to certify that I, <b>{candidateData?.first_name} {candidateData?.middle_name} {candidateData?.last_name}</b>, Indian Citizen, of Legal Age - <b>{candidateData?.age}</b>, son/daughter of <b>{candidateData?.father_name}</b> and resident of</p>

                        <TextField
                            label={fields?.declaration_address?.label}
                            id={fields?.declaration_address?.id}
                            errId={`err-${fields?.declaration_address?.id}`}
                            name='address'
                            value={fields?.declaration_address?.value || address}
                            inputText={handleInputChange}
                            placeholder="Enter your address"
                            isRequired={fields?.declaration_address?.is_mandatory}
                            required
                        />
                        <p>hereby declare that:</p>
                        <p>There are no civil and/or criminal case(s) pending against me in any court of law.</p>
                        <p>That I have never been convicted by any court of law for any civil or criminal offence and there is no criminal case pending against me.</p>
                        <p>I am executing this declaration in support of my application for employment at Nestlé India Limited. I understand that any misrepresentation as to the truth of the foregoing shall case in disapproval of my application and/or termination of employment without prejudice to the filing of civil and/or criminal case(s) against me.</p>
                        <button onClick={handleSubmit} className="btn btn-primary">Submit</button>
                    </div>
                )}

                {hasCourtRecord === true && (
                    <div className="my-3">
                        <p>Enter CNR/Registration Number of cases (You can enter multiple values separated by commas)</p>
                        <TextField
                            label="CNR/Registration Numbers"
                            // value={cnrNumbers}
                            id={fields?.declaration_cnr_number?.id}
                            errId={`err-${fields?.declaration_cnr_number?.id}`}
                            inputText={handleInputChange}
                            value={fields?.declaration_cnr_number?.value || cnrNumbers}
                            name='CNR'
                            placeholder="Enter CNR numbers"
                            isRequired={fields?.declaration_cnr_number?.is_mandatory}
                            required
                        />
                        <p>Note: All the information entered will be migrated as an Antecedent to Bridge.</p>
                        <button onClick={(e)=>handleSubmit(e)} className="btn btn-primary">Submit</button>
                    </div>
                )}
                {formData?.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
            </div>
        </>
    );
};

export default MainFormCourtRecordCheckDeclaration;
